//Main
import vue from "vue"
import vapi from "vuex-rest-api"
import vuex from "vuex"
import store from "./index.js"

vue.use(vuex);

//store
const cuestionario = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/cuestionario`,
    state: {
        cuestionarios: []
    }
}).get({
    action: "get_cuestionario",
    onSuccess: (state, payload) => {
        state.cuestionarios = payload.data;
    }
}).get({
    action: "get_cuestionariosbyavancenacional",
    path: function (obj) {
        return `/avancenacional/${obj.idavancenacional}`
    }, 
    onSuccess: (state, payload) => {
        state.cuestionarios = payload.data;
    }
}).post({
    action: "post_cuestionario",   
    onSuccess: (state, payload) => {     
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => { 
        store.dispatch("mensaje/set_error", error);
    }    
}).getStore();

cuestionario.getters = {
    gcuestionarios: state => {
        return state.cuestionarios;
    }
}

export default cuestionario;
